import { useABTesting } from './abTesting';

export enum ExpManageWithdrawalExpectations {
  A = 'exp_lu_manage_withdrawal_expectations_a',
  B = 'exp_lu_manage_withdrawal_expectations_b',
}

export const useIsExpWithdrawalExpectations = () => {
  const version = useABTesting('exp_lu_manage_withdrawal_expectations', {
    defaultVersion: ExpManageWithdrawalExpectations.A,
    versions: [
      { name: ExpManageWithdrawalExpectations.A, probability: 50 },
      { name: ExpManageWithdrawalExpectations.B, probability: 50 },
    ],
  });

  return version === ExpManageWithdrawalExpectations.B;
};
